import { Container, Typography, Stack, Box } from "@mui/material";
import Cover from "../../Components/Misc/Cover";
import HourglassTopRoundedIcon from "@mui/icons-material/HourglassTopRounded";
import PendingIcon from "../../Components/Misc/PendingIcon";
import { cacheService } from "../../Core/Api/services";
import { useTranslation } from "react-i18next";

function NewUserWaiting() {
  const { t } = useTranslation();
  return (
    <Box display="flex" minHeight="100vh">
      <Stack direction="row" flex={1} position="relative">
        <Cover img={{ src: "/static/images/view-link-cover-fallback.png" }} />
        <Stack alignItems="center" justifyContent="center" width="100%" position="relative">
          <Container sx={{ textAlign: "center" }}>
            <PendingIcon sx={{ mr: "auto", ml: "auto" }} icon={<HourglassTopRoundedIcon />} />
            <Typography mt={4} mb={2.5} component="h1" variant="h3">
              {t("page:body.accountCreated")}
            </Typography>
            <Typography component="p" variant="subtitle2" color="text.tier" fontWeight={400} textAlign="center" mb={4}>
              {t("page:body.accountCreatedPendingReview", { authMode: cacheService.GetUserInfo()?.authMode })}
            </Typography>
          </Container>
        </Stack>
      </Stack>
    </Box>
  );
}

export default NewUserWaiting;
